import { Component, OnInit, Inject } from '@angular/core';
import { VERSION, MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'bil-aoa-modal',
  templateUrl: './aoa-modal.component.html',
  styleUrls: ['./aoa-modal.component.sass']
})
export class AoaModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AoaModalComponent>) {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
